import { render, staticRenderFns } from "./RegistryList.vue?vue&type=template&id=e45f2238&scoped=true"
import script from "./RegistryList.vue?vue&type=script&lang=js"
export * from "./RegistryList.vue?vue&type=script&lang=js"
import style0 from "./RegistryList.vue?vue&type=style&index=0&id=e45f2238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45f2238",
  null
  
)

export default component.exports